import React from "react";

type InputWithIconsProps = {
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  placeholder?: string;
  type?: string;
  className?: string;
};

const InputWithIcons: React.FC<InputWithIconsProps> = ({
  leftIcon,
  rightIcon,
  placeholder = "",
  type = "text",
  className = "",
}) => {
  return (
    <div className={`relative ${className}`}>
      {/* Left Icon */}
      {leftIcon && (
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
          {leftIcon}
        </span>
      )}

      {/* Input */}
      <input
        type={type}
        placeholder={placeholder}
        className={`w-full rounded-md border border-gray-300 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 ${className} ${
          leftIcon ? "pl-10" : "pl-3"
        } ${rightIcon ? "pr-10" : "pr-3"}`}
      />

      {/* Right Icon */}
      {rightIcon && (
        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">
          {rightIcon}
        </span>
      )}
    </div>
  );
};

export default InputWithIcons;
